import React, { useState } from "react";
import Naira from "react-naira";
import "./SelectPayment.scss";
import * as MdIcons from "react-icons/md";
import { connect } from "react-redux";
import { useForm, Form } from "../../../controls/useForm";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import PaymentIcon from "@material-ui/icons/Payment";
import { Toolbar } from "@material-ui/core";
import {
  selectCartItems,
  selectCartTotal,
} from "../../../../redux-store/reducers/cart-reducer/cart.selector";

var record = [];
const initialFValues = {
  cashRecieved: "",
  customerName: "",
  accountId: 0,
  sendBy: "",
  referenceNumber: "",
  customerId: 0,
  phoneNumber: "",
  paymentTypeId: 0,
  accountTypeId: 0,
  cardTypeId: 0,
};

const SelectPayment = ({
  cartItems,
  total,
  AddOrders,
  AddCheckOutOrders,
  ClearCart,
  LoadPayments,
  drop,
  vat,
  discount,
  companyId,
  AddPayment,
  categories,
  OrderDetails,
  vatcal,
  discountcal,
  accounts,
  accountTypes,
  paymentTypes,
  cardTypes,
}) => {
  const addPayment = (payment, resetForm) => {
    var data = {
      ...payment,
      companyId: companyId,
      cashRecieved: values.cashRecieved,
      salesOrders: cartItems,
      vat: vat,
      discount: discount,
      customerId: values.customerId,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: "jokoyoski",
      referenceNumber: "234494932",
    };
    AddPayment(data);
    //setRecordForEdit(null);
    // setAddOpenPopup(false);
  };
  const payCash = () => {
    var data = {
      paymentTypeId: 2,
      salesOrders: cartItems,
      cashRecieved: values.cashRecieved,
      vat: vat ?? 0,
      discount: discount ?? 0,
      vatcal: vatcal ?? 0,
      discountcal: discountcal ?? 0,
      customerId: values.customerId,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: values.sendBy,
      accountId: 0,
      cardTypeId: 0,
      accountTypeId: 0,
    };
    AddPayment(data);
  };
  const payTransfer = () => {
    var data = {
      paymentTypeId: 5,
      salesOrders: cartItems,
      vat: vat ?? 0,
      cashRecieved: values.cashRecieved,
      customerId: values.customerId,
      vatcal: vatcal ?? 0,
      discountcal: discountcal ?? 0,
      discount: discount ?? 0,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: values.sendBy,
      sendBy: values.sendBy,
      accountId: values.accountId,
      cardTypeId: values.cardTypeId,
      accountTypeId: values.accountTypeId,
      referenceNumber: values.referenceNumber,
    };
    AddPayment(data);
  };

  const payCard = () => {
    var data = {
      paymentTypeId: 1,
      salesOrders: cartItems,
      vat: vat,
      discount: discount ?? 0,
      vatcal: vatcal ?? 0,
      discountcal: discountcal ?? 0,
      customerId: values.customerId,
      cashRecieved: values.cashRecieved,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: values.sendBy,
      accountId: values.accountId,
      cardTypeId: values.cardTypeId,
      accountTypeId: values.accountTypeId,
      referenceNumber: values.referenceNumber,
    };

    AddPayment(data);
  };
  const payUssd = () => {
    var data = {
      paymentTypeId: 4,
      salesOrders: cartItems,
      vat: vat,
      vatcal: vatcal ?? 0,
      discountcal: discountcal ?? 0,
      customerId: values.customerId,
      discount: discount ?? 0,
      cashRecieved: values.cashRecieved,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: values.sendBy,
      accountId: values.accountId,
      cardTypeId: values.cardTypeId,
      accountTypeId: values.accountTypeId,
      referenceNumber: values.referenceNumber,
    };
    for (var i = 0; i < data.salesOrders.length; i++) {
      data[i].imageId = "";
    }
    AddPayment(data);
  };
  const payCheque = () => {
    var data = {
      paymentTypeId: 4,
      salesOrders: cartItems,
      vat: vat ?? 0,
      discount: discount ?? 0,
      vatcal: vatcal ?? 0,
      discountcal: discountcal ?? 0,
      customerId: values.customerId,
      cashRecieved: values.cashRecieved,
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: values.sendBy,
      accountId: values.accountId,
      cardTypeId: values.cardTypeId,
      accountTypeId: values.accountTypeId,
      referenceNumber: values.referenceNumber,
    };
    AddPayment(data);
  };

  const prepareOrder = () => {
    var i = 0;
    for (i; i < cartItems.length; i++) {
      record[i] = {
        quantity: cartItems[i].quantity,
        sku: cartItems[i].sku,
      };
    }

    var value = {
      salesOrders: record,
      transactionReference: cartItems[0]?.transactionReference,
    };
    AddOrders(value);
  };
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, () => { });

  return (
    <>
      <div>
        {/* Button trigger modal */}


        <button
          type="button"
          className="btn btn-success"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          Select Payment
        </button>
        {/* Modal */}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {" "}
                  <strong>Select Payment Mode</strong>
                </h5>
                <MdIcons.MdCancel
                  style={{ fontSize: "1.5rem", cursor: "pointer" }}
                  className="text-danger close"
                  data-dismiss="modal"
                  aria-label="Close"
                  aria-hidden="true"
                />
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-center align-items-center mt-2 mb-4">
                  <div className="card">
                    <ul
                      className="nav nav-pills mb-3"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item text-center">
                        {" "}
                        <a
                          className="nav-link active btl"
                          id="pills-home-tab"
                          data-toggle="pill"
                          href="#pills-home"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          Cash
                        </a>{" "}
                      </li>
                      <li className="nav-item text-center">
                        {" "}
                        <a
                          className="nav-link btr"
                          id="pills-profile-tab"
                          data-toggle="pill"
                          href="#pills-profile"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Card
                        </a>{" "}
                      </li>
                      <li className="nav-item text-center">
                        {" "}
                        <a
                          className="nav-link btr"
                          id="pills-transfer-tab"
                          data-toggle="pill"
                          href="#pills-transfer"
                          role="tab"
                          aria-controls="pills-transfer"
                          aria-selected="false"
                        >
                          Transfer
                        </a>{" "}
                      </li>
                      <li className="nav-item text-center">
                        {" "}
                        <a
                          className="nav-link btr"
                          id="pills-ussd-tab"
                          data-toggle="pill"
                          href="#pills-ussd"
                          role="tab"
                          aria-controls="pills-ussd"
                          aria-selected="false"
                        >
                          USSD
                        </a>{" "}
                      </li>
                      <li className="nav-item text-center">
                        {" "}
                        <a
                          className="nav-link btr"
                          id="pills-cheque-tab"
                          data-toggle="pill"
                          href="#pills-cheque"
                          role="tab"
                          aria-controls="pills-cheque"
                          aria-selected="false"
                        >
                          Cheque
                        </a>{" "}
                      </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="form px-4">
                          {" "}
                          <div className="pb-4">
                            <h4>
                              <strong>Cash Payment</strong>
                            </h4>
                            <small>
                              Enter the Cash Transaction Details Here
                            </small>
                          </div>
                          <Grid container>
                            <Grid item xs={6}>
                              <div className="pb-3">
                                <Controls.Input
                                  name="cashRecieved"
                                  label="Cash Recieved"
                                  value={values.cashRecieved || ""}
                                  onChange={handleInputChange}
                                  error={errors.cashRecieved}
                                />
                              </div>
                              <div >
                                <Controls.Select
                                  name="customerId"
                                  label="Customer"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />
                              </div>
                            </Grid>
                          </Grid>
                          {/*   <div>
                                                        <input
                                                            type="text"
                                                            name
                                                            className="form-control"
                                                            placeholder="Balance"
                                                        />{" "}
                                                    </div>

                                                    <div>
                                                        <input
                                                            type="text"
                                                            name
                                                            className="form-control"
                                                            placeholder="Amount Paid"
                                                        />{" "}
                                              </div>*/}
                          <button className="btn btn-dark btn-block">
                            Cancel
                          </button>{" "}
                          <button
                            onClick={() => payCash()}
                            className="btn btn-primary btn-block"
                          >
                            Continue
                          </button>{" "}
                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="pills-profile"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                      >
                        <div className="form px-4">
                          {" "}
                          <div className="pb-4">
                            <h4>
                              <strong>Card Payment</strong>
                            </h4>
                            <small>
                              Enter the Card Transaction Details Here
                            </small>
                          </div>
                          <Form>
                            <Grid container>
                              <Grid item xs={6}>
                                <Controls.Input
                                  name="cashRecieved"
                                  label="Cash Recieved"
                                  value={values.cashRecieved || ""}
                                  onChange={handleInputChange}
                                  error={errors.cashRecieved}
                                />

                                <Controls.Select
                                  name="customerId"
                                  label="Customer"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />
                                <Controls.Input
                                  label="Reference Number"
                                  name="referenceNumber"
                                  value={values.referenceNumber || ""}
                                  onChange={handleInputChange}
                                  error={errors.referenceNumber}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Controls.Select
                                  name="accountTypeId"
                                  label="Account Type"
                                  value={values.accountTypeId || ""}
                                  onChange={handleInputChange}
                                  options={accountTypes}
                                  error={errors.accountTypeId}
                                />
                                <Controls.Select
                                  name="accountId"
                                  label="Account"
                                  value={values.accountId || ""}
                                  onChange={handleInputChange}
                                  options={accounts}
                                  error={errors.accountTypeId}
                                />
                                <Controls.Select
                                  name="customerId"
                                  label="Drop"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />
                                <Controls.Select
                                  name="cardTypeId"
                                  label="Card Type"
                                  value={values.cardTypeId || ""}
                                  onChange={handleInputChange}
                                  options={cardTypes}
                                  error={errors.cardTypeId}
                                />
                              </Grid>
                            </Grid>
                          </Form>
                          <button className="btn btn-dark btn-block">
                            Cancel
                          </button>{" "}
                          <button
                            onClick={() => payCard()}
                            className="btn btn-primary btn-block"
                          >
                            Continue
                          </button>{" "}
                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="pills-transfer"
                        role="tabpanel"
                        aria-labelledby="pills-transfer-tab"
                      >
                        <div className="form px-4">
                          {" "}
                          <div className="pb-4">
                            <h4>
                              <strong>Bank Transfer</strong>
                            </h4>
                            <small>Enter the Transaction Details Here</small>
                          </div>
                          <Form>
                            <Grid container>
                              <Grid item xs={6}>
                                <Controls.Input
                                  name="cashRecieved"
                                  label="Cash Recieved"
                                  value={values.cashRecieved || ""}
                                  onChange={handleInputChange}
                                  error={errors.cashRecieved}
                                />

                                <Controls.Input
                                  label="Reference Number"
                                  name="referenceNumber"
                                  value={values.referenceNumber || ""}
                                  onChange={handleInputChange}
                                  error={errors.referenceNumber}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Controls.Select
                                  name="accountTypeId"
                                  label="Account Type"
                                  value={values.accountTypeId || ""}
                                  onChange={handleInputChange}
                                  options={accountTypes}
                                  error={errors.accountTypeId}
                                />
                                <Controls.Select
                                  name="accountId"
                                  label="Account"
                                  value={values.accountId || ""}
                                  onChange={handleInputChange}
                                  options={accounts}
                                  error={errors.accountTypeId}
                                />

                                <Controls.Select
                                  name="customerId"
                                  label="Customer"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />
                                <Controls.Select
                                  name="cardTypeId"
                                  label="Card Type"
                                  value={values.cardTypeId || ""}
                                  onChange={handleInputChange}
                                  options={cardTypes}
                                  error={errors.cardTypeId}
                                />
                              </Grid>
                            </Grid>
                          </Form>
                          <button className="btn btn-dark btn-block">
                            Cancel
                          </button>{" "}
                          <button
                            onClick={() => payTransfer()}
                            className="btn btn-primary btn-block"
                          >
                            Continue
                          </button>{" "}
                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="pills-ussd"
                        role="tabpanel"
                        aria-labelledby="pills-ussd-tab"
                      >
                        <div className="form px-4">
                          {" "}
                          <div className="pb-4">
                            <h4>
                              <strong>USSD Text</strong>
                            </h4>
                            <small>Enter the Transaction Details Here</small>
                          </div>
                          <Form>
                            <Grid container>
                              <Grid item xs={6}>
                                <Controls.Input
                                  name="cashRecieved"
                                  label="Cash Recieved"
                                  value={values.cashRecieved || ""}
                                  onChange={handleInputChange}
                                  error={errors.cashRecieved}
                                />
                                <Controls.Select
                                  name="customerId"
                                  label="Customer"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />

                                <Controls.Input
                                  label="Reference Number"
                                  name="referenceNumber"
                                  value={values.referenceNumber || ""}
                                  onChange={handleInputChange}
                                  error={errors.referenceNumber}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Controls.Select
                                  name="accountId"
                                  label="Account"
                                  value={values.accountId || ""}
                                  onChange={handleInputChange}
                                  options={accounts}
                                  error={errors.accountTypeId}
                                />
                              </Grid>
                            </Grid>
                          </Form>
                          <button className="btn btn-dark btn-block">
                            Cancel
                          </button>{" "}
                          <button
                            onClick={() => payUssd()}
                            className="btn btn-primary btn-block"
                          >
                            Continue
                          </button>{" "}
                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="pills-cheque"
                        role="tabpanel"
                        aria-labelledby="pills-cheque-tab"
                      >
                        <div className="form px-4">
                          {" "}
                          <div className="pb-4">
                            <h4>
                              <strong>Cheque</strong>
                            </h4>
                            <small>Enter the Transaction Details Here</small>
                          </div>
                          <Form>
                            <Grid container>
                              <Grid item xs={6}>
                                <Controls.Input
                                  name="cashRecieved"
                                  label="Cash Recieved"
                                  value={values.cashRecieved || ""}
                                  onChange={handleInputChange}
                                  error={errors.cashRecieved}
                                />
                                <Controls.Select
                                  name="customerId"
                                  label="Drop"
                                  value={values.customerId || ""}
                                  onChange={handleInputChange}
                                  options={drop}
                                  error={errors.dropId}
                                />

                                <Controls.Input
                                  label="Reference Number"
                                  name="referenceNumber"
                                  value={values.referenceNumber || ""}
                                  onChange={handleInputChange}
                                  error={errors.referenceNumber}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Controls.Select
                                  name="accountId"
                                  label="Account"
                                  value={values.accountId || ""}
                                  onChange={handleInputChange}
                                  options={accounts}
                                  error={errors.accountTypeId}
                                />
                              </Grid>
                            </Grid>
                          </Form>
                          <button className="btn btn-dark btn-block">
                            Cancel
                          </button>{" "}
                          <button
                            onClick={() => payCheque()}
                            className="btn btn-primary btn-block"
                          >
                            Continue
                          </button>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: selectCartItems(state), // from the selector we pass in the state
    total: selectCartTotal(state),
    orderId: state.salesReducer.orderId,
    payments: state.salesReducer.payments,
    accountTypes: state.salesReducer.accountTypes,
    vat: state.salesReducer.vat,
    vatcal: state.salesReducer.vatcal,
    discountcal: state.salesReducer.discountcal,
    discount: state.salesReducer.discount,
    accounts: state.salesReducer.accounts,
    drop: state.userReducer.drop,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
  };
};

const mapToDispatchToProps = (dispatch) => ({
  LoadOrders(payload) {
    dispatch({ type: "LOAD_SALES_PRODUCT_LIST", payload });
  },
  ClearCart: () => dispatch({ type: "CLEAR_CART" }), //setting the values,
  AddOrders(payload) {
    dispatch({ type: "SAVE_ORDERS", payload });
  },
  AddCheckOutOrders(payload) {
    dispatch({ type: "SAVE_ORDERS_FOR_CHECKOUT", payload });
  },
  AddPayment(payload) {
    dispatch({ type: "ADD_PAYMENT", payload });
  },
  OrderDetails(payload) {
    dispatch({ type: "LOAD_ORDER_DETAILS", payload });
  },

  LoadPayments(payload) {
    dispatch({ type: "LOAD_PAYMENT_DETAILS", payload });
  },
  //object we are passing into the component
  // AddItem: (item) => dispatch(AddItem(item)), //setting the values,
});

export default connect(mapStateToProps, mapToDispatchToProps)(SelectPayment); //higher order component
